import { Briefcase, Users } from "lucide-react";
import { useState } from "react";

import TriggerTab from "../TabTrigger";
import BasicForm from "../form/BasicForm";
import WorkForm from "../form/WorkForm";

import FormDialog from "@/components/reusables/FormDialog";
import { Tabs, TabsContent, TabsList } from "@/components/ui/tabs";
import useQueryParams from "@/hooks/useQueryParams";

const tabContent = [
  { value: 1, label: "Basic", Icon: Users },
  { value: 2, label: "Work", Icon: Briefcase },
] as const;

const UpdateEmployeeModal = ({
  isOpen,
  toggleModal,
}: {
  isOpen: boolean;
  toggleModal: () => void;
}): React.JSX.Element => {
  const [activeTab, setActiveTab] = useState("1");
  const { clearParam } = useQueryParams();
  const [isFormDirty, setIsFormDirty] = useState(false);

  const handleExit = (): void => {
    toggleModal();
    clearParam("id");
  };

  return (
    <FormDialog
      isOpen={isOpen}
      toggleModal={handleExit}
      title='Update Employee'
      isFormDirty={isFormDirty}
      className='sm:max-w-lg md:max-w-5xl'
    >
      <>
        <Tabs
          defaultValue='1'
          value={activeTab}
          onValueChange={(value) => setActiveTab(value)}
          className='mt-4'
        >
          <TabsList className='flex items-center justify-center mb-12 bg-transparent'>
            {tabContent.map((content) => (
              <TriggerTab
                key={content.value}
                value={content.value.toString()}
                Icon={content.Icon}
                label={content.label}
              />
            ))}
          </TabsList>

          <TabsContent value={"1"}>
            <BasicForm
              setActiveTab={setActiveTab}
              operationType='edit'
              setIsFormDirty={setIsFormDirty}
            />
          </TabsContent>
          <TabsContent value='2'>
            <WorkForm
              setActiveTab={setActiveTab}
              handleExit={handleExit}
              operationType='edit'
              setIsFormDirty={setIsFormDirty}
            />
          </TabsContent>
        </Tabs>
      </>
    </FormDialog>
  );
};

export default UpdateEmployeeModal;
